import { render, staticRenderFns } from "./ImgWithCroper.vue?vue&type=template&id=6c2ea502"
import script from "./ImgWithCroper.vue?vue&type=script&lang=js"
export * from "./ImgWithCroper.vue?vue&type=script&lang=js"
import style0 from "./ImgWithCroper.vue?vue&type=style&index=0&id=6c2ea502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports